import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FormGroup, FormControl, FormLabel, FormCheck, Form, Button, Alert } from "react-bootstrap/";
import LoaderButton from "../components/LoaderButton";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faEnvelope, faLock, faEye, faEyeSlash, faChevronRight } from '@fortawesome/free-solid-svg-icons'


import { useAppContext } from "../libs/contextLib";
import { useHistory, useLocation } from "react-router-dom";
import { useFormFields } from "../libs/hooksLib";
import { useAnalytics } from "../libs/analytics";
// import { useRecaptcha } from "../libs/recaptchLib";

import { onError, Notification } from "../libs/errorLib";
import { API } from "aws-amplify";
import Cookie, { set } from 'js-cookie';

import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";

import "./Login.css";
import CardGroup from '../components/common/CardGroup';

export default function LoginOrSignup(props) {
  const { 
    showGuestOption = false, // Only show guest option when coming from checkout
    onGuestContinue, // Callback for guest option
    ...otherProps 
  } = props;

  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const { trackEvent } = useAnalytics();
  const { isAuthenticated, userHasAuthenticated, getSession, setSession, login, signup } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(true)
  const [isSignup, setIsSignup] = useState(false)
  const [fields, handleFieldChange] = useFormFields({
    email: searchParams.get('email') || "",
    confirmEmail: "",
    password: "",
    fullname: "",
    confirmPassword: "",
  });
  const [curSession, setCurSession] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showSignupPassword, setShowSignupPassword] = useState(false);
  const [showSignupConfirmPassword, setShowSignupConfirmPassword] = useState(false);
  // const { initRecaptcha, executeRecaptcha } = useRecaptcha();

  // Check if this is coming from checkout flow
  const redirectPath = searchParams.get('redirect');
  const isFromCheckout = redirectPath && redirectPath.includes('/cart/checkout');
  const shouldShowGuestOption = showGuestOption || isFromCheckout;

  useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      console.log(searchParams)
      if (searchParams.get('code')) {
        handleFieldChange({ target: { id:'purchaseCode', name: 'purchaseCode', value: searchParams.get('code') }})
      }    
    

      async function initSession() {
        let session = await getSession()
        if (session) {
          setCurSession(session)
        }
      }
      initSession()

      // initRecaptcha()
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    
    if (location?.state?.isSignup) {
      setIsLogin(location?.state?.isLogin)
      setIsSignup(location?.state?.isSignup)
    }
    
  }, [location]);

  

  // useEffect(() => {
  //   const loadScriptByURL = (id, url, callback) => {
  //     const isScriptExist = document.getElementById(id);
   
  //     if (!isScriptExist) {
  //       var script = document.createElement("script");
  //       script.type = "text/javascript";
  //       script.src = url;
  //       script.id = id;
  //       script.onload = function () {
  //         if (callback) callback();
  //       };
  //       document.body.appendChild(script);
  //     }
   
  //     if (isScriptExist && callback) callback();
  //   }
   
    
  //   // console.log('loading recaptcha')
  //   // load the script by passing the URL
  //   loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
  //     console.log("recaptcha v4 loaded!");
  //   });
  // }, []);

  // function verifyRecaptcha(token) {
  //   let result = API.post("vivelo", "/auth/recaptcha/verify", {
  //     body: { token: token }
  //   });
  //   return result
  // }

  function validateForm() {
    const loginOk = fields.email.length > 0 && fields.password.length > 0      
    const signupOk = fields.fullname.length > 0 && fields.email.length > 0 &&
      fields.password.length > 0 &&
      fields.email === fields.confirmEmail &&
      fields.password === fields.confirmPassword;    

    if (isLogin) {
      return loginOk
    }
    if (isSignup) {
      return signupOk
    }    
  }

  async function handleSubmit(event) {    
      event.preventDefault(); 

      trackEvent({
        action: "Clicked Activate Button",
        category: "PurchaseFunnel"
      });
            
      try {
        setIsLoading(true);

        let session = await getSession()
        console.log(isAuthenticated, session)
        if (!isAuthenticated && !session) {
            if (isLogin) {
              session = await login(fields.email, fields.password)
              if (!session) {
                Notification('error', 'Usuario o contraseña inválidos')
              }
            } else {
              // const captchaResult = await executeRecaptcha('signup')
              // if (captchaResult.success) {
              //   console.log('success ', captchaResult)
                // session = await signup(fields.fullname, fields.email, fields.password, ['Viewer'])
                session = await signup(fields.fullname, fields.email, fields.password, ['Viewer'])
                if (session === false) {
                  Notification('error', 'Ya existe un usuario registrado con ese correo')
                }
              // } else {
              //   Notification('error', 'Error de verificación.  Por favor vuelve a intentar.')
              // }
              
              
            }
        }

      } catch (err) {
        onError(err)
        if (err.response) {
          console.error("activation error status", err.response)
          switch(err.response.status) {
            case 401: {
              Notification('error','Usuario o contraseña inválida')
              break;
            }            
            default: {                            
              Notification('error','Error de autenticación')
              break;
            }
          }
        } else {
          console.error("activation exception", err)
          Notification('error','Ocurrió un error')
        }
      } finally {
        setIsLoading(false);
      }
  }

  function handleGuestContinue() {
    if (onGuestContinue) {
      onGuestContinue()
    } else if (isFromCheckout) {
      // If coming from checkout, redirect to a guest checkout route
      history.push('/cart/checkout/guest')
    }
  }

  function renderGuestOption() {
    if (!shouldShowGuestOption) return null;

    return (
      <div className="guest-option-section">
        <div className="guest-option-divider">
          <span>o</span>
        </div>
        <button 
          className="guest-continue-btn"
          onClick={handleGuestContinue}
          type="button"
        >
          <FontAwesomeIcon icon={faChevronRight} />
          Continuar como invitado
        </button>
      </div>
    );
  }

  function renderSignupFields() {
    return (
      <div>
        <h1 className="title">Crea tu cuenta</h1>
        <CardGroup>
          <Form.Group controlId="fullname" size="lg">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              className="input-theme"
              type="text"
              placeholder="Tu nombre completo"
              value={fields.fullname}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group controlId="email" size="lg">
            <Form.Label>Correo electrónico</Form.Label>
            <Form.Control
              className="input-theme"
              type="email"
              placeholder="tu@email.com"
              value={fields.email}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group controlId="confirmEmail" size="lg">
            <Form.Label>Confirma tu correo</Form.Label>
            <Form.Control
              className="input-theme"
              type="email"
              placeholder="Confirma tu correo"
              value={fields.confirmEmail}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group controlId="password" size="lg">
            <Form.Label>Contraseña</Form.Label>
            <div className="input-icon-group">
              <Form.Control
                className="input-theme"
                type={showSignupPassword ? "text" : "password"}
                placeholder="••••••••"
                value={fields.password}
                onChange={handleFieldChange}
                style={{ paddingRight: 44 }}
              />
              <span
                className="input-icon-right"
                onClick={() => setShowSignupPassword(!showSignupPassword)}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon icon={showSignupPassword ? faEyeSlash : faEye} />
              </span>
            </div>
          </Form.Group>
          <Form.Group controlId="confirmPassword" size="lg">
            <Form.Label>Confirma tu contraseña</Form.Label>
            <div className="input-icon-group">
              <Form.Control
                className={fields.password != fields.confirmPassword ? "input-theme field-error" : "input-theme field-ok"}
                type={showSignupConfirmPassword ? "text" : "password"}
                placeholder="Confirma tu contraseña"
                value={fields.confirmPassword}
                onChange={handleFieldChange}                
                style={{ paddingRight: 44 }}
              />
              <span
                className="input-icon-right"
                onClick={() => setShowSignupConfirmPassword(!showSignupConfirmPassword)}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon icon={showSignupConfirmPassword ? faEyeSlash : faEye} />
              </span>
            </div>
          </Form.Group>
          <Button
            className="btn-theme-primary"
            block
            type="submit"
            size="lg"
            disabled={!validateForm()}
            style={{marginTop: 18, marginBottom: 8}}
          >
            Crear cuenta
          </Button>
          <div className="login-footer">
            ¿Ya tienes una cuenta? <a href="#" onClick={goToLogin} className="login-link-register">Inicia sesión</a>
          </div>
        </CardGroup>
      </div>
    );
  }

  function renderLoginFields() {
    return (
      <div>
        <h1 className="title">Iniciar sesión</h1>
        <CardGroup>
          <Form.Group controlId="email" size="lg">
            <Form.Label>Correo electrónico</Form.Label>
            <div className="input-icon-group">
              {/* <span className="input-icon-left">
                <FontAwesomeIcon icon={faEnvelope} />
              </span> */}
              <Form.Control
                className="input-theme"
                type="email"
                placeholder="tu@email.com"
                value={fields.email}
                onChange={handleFieldChange}
                autoComplete="email"
                style={{ paddingLeft: 44 }}
              />
            </div>
          </Form.Group>
          <Form.Group controlId="password" size="lg">
            <Form.Label>Contraseña</Form.Label>
            <div className="input-icon-group">
              {/* <span className="input-icon-left">
                <FontAwesomeIcon icon={faLock} />
              </span> */}
              <Form.Control
                className="input-theme"
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={fields.password}
                onChange={handleFieldChange}
                autoComplete="current-password"
                style={{ paddingLeft: 44, paddingRight: 44 }}
              />
              <span className="input-icon-right" onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </span>
            </div>
          </Form.Group>
          <div className="login-row login-row-between">
            {/* <Form.Check type="checkbox" label="Recordarme" style={{marginBottom:0}} /> */}
            <a href="/password/recover" className="login-link-forgot">¿Olvidaste tu contraseña?</a>
          </div>
          <Button
            className="btn-theme-primary"
            block
            type="submit"
            size="lg"
            disabled={!validateForm()}
            style={{marginTop: 18, marginBottom: 8}}
          >
            Iniciar sesión
          </Button>
          {/* <div className="login-divider"><span>O continúa con</span></div>
          <div className="login-social-row">
            <Button className="btn-theme-secondary login-social-btn" block><FontAwesomeIcon icon={["fab", "google"]} /> Google</Button>
            <Button className="btn-theme-secondary login-social-btn" block><FontAwesomeIcon icon={["fab", "facebook"]} /> Facebook</Button>
          </div> */}
          <div className="login-footer">
            ¿No tienes una cuenta? <a href="#" onClick={goToSignup} className="login-link-register">Regístrate aquí</a>
          </div>
        </CardGroup>
      </div>
    );
  }
   
  function goToLogin(e) {
    e.preventDefault()
    setIsLogin(true)
    setIsSignup(false)
  }

  function goToSignup(e) {
    e.preventDefault()
    setIsLogin(false)
    setIsSignup(true)
  }

  function renderForm() {
    return (
      <div className="login-center-container">
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          {isLogin && renderLoginFields()}
          {isSignup && renderSignupFields()}
        </form>
        {renderGuestOption()}
      </div>
    );
  }

  return (
    <div className="content content-dark">
      {renderForm()}
    </div>
  );
}